import Vue from 'vue';
import VueResource from 'vue-resource';
import BootstrapVue from 'bootstrap-vue';

// UI
import {
  Components,
  Directives,
  Plugins,
  Mixins,
} from 'vue-ui';

import VueI18n from 'vue-i18n';
import App from './App.vue';
import router from './router';

/** Lacalization * */
import Languages from './i18n';

/** Vuex * */
import store from './vuex/Store';

/** Global Mixins * */
import AuthMixins from './mixins/AuthMixins';
import ConfigsMixins from './mixins/ConfigsMixins';
import NotificationsMixins from './mixins/NotificationsMixins';
import ErrorsMixins from './mixins/ErrorsMixins';
import RoutingMixins from './mixins/RoutingMixins';

// Register UI components
Object.keys(Components).forEach((name) => {
  Vue.component(name, Components[name]);
});

// Register UI directives
Object.keys(Directives).forEach((id) => {
  Vue.directive(id, Directives[id]);
});

// Register UI plugins
Object.values(Plugins).forEach((plugin) => {
  Vue.use(plugin);
});

// Register UI Mixins
Object.values(Mixins).forEach((mixin) => {
  Vue.mixin(mixin);
});

Vue.use(VueResource);
Vue.use(BootstrapVue);
Vue.use(VueI18n);

Vue.mixin(AuthMixins);
Vue.mixin(NotificationsMixins);
Vue.mixin(ErrorsMixins);
Vue.mixin(ConfigsMixins);
Vue.mixin(RoutingMixins);

const i18n = new VueI18n({
  locale: 'en',
  messages: Languages.messagesOnly(),
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>',
});
